import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  OnInit,
  signal,
  ViewChild,
} from "@angular/core";
import * as download from "downloadjs";
import { FooterDataService } from "../../footer-data.service";
import { BreakpointObserver, BreakpointState } from "@angular/cdk/layout";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  standalone: false,
})
export class FooterComponent implements OnInit {
  private footerdataservice = inject(FooterDataService);
  private breakPointObserver = inject(BreakpointObserver);
  private destroyRef = inject(DestroyRef);

  footerData = this.footerdataservice.getfooterData().footerSections;
  isAccordionOpen = signal<boolean[]>([]);
  isMobile = signal<boolean>(false);

  ngOnInit(): void {
    this.isAccordionOpen.set(this.footerData.map(() => false));
    this.getScreenSize();
  }

  toggleAccordion(index: number): void {
    const current = this.isAccordionOpen();
    const updated = current.map((_, i) => i === index ? !current[i] : false);
    this.isAccordionOpen.set(updated);
  }
  

  downloadpdf(url: string): void {
    download(url);
  }

  getScreenSize() {
    const max580$ = ["(max-width: 580px)"];
    this.breakPointObserver
      .observe(max580$)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((matches: BreakpointState) => {
        this.isMobile.set(matches.matches);
      });

  }
}
